import React, { useState, useEffect } from 'react';
import { Form, Typography, Modal, Input, Popover, Row, Col, Table, message, Tag, Popconfirm } from 'antd';
import Created from '../../components/commons/table-views/created';
import Modified from '../../components/commons/table-views/modified';
import { DateAndTimeFormat } from '../../config/config';
import FeatherIcon from 'feather-icons-react';
import useApiFetch from '../../hooks/useApiFetch';
// import { Link } from 'react-router-dom';
// import { UserTableStyleWrapper } from '../pages/style'

import { PageHeader } from '../../components/page-headers/page-headers';
import { Main, CardToolbox, TableWrapper, BasicFormWrapper } from '../styled';
import { Button } from '../../components/buttons/buttons';
import { Cards } from '../../components/cards/frame/cards-frame';
import qs from 'qs';
import { useAuth } from '../../context/auth.context';

function IndustriesList() {
    const { apiClient } = useAuth();
    const [searchText, setSearchText] = useState('');
    const [updatingIndustries, setUpdatingIndustries] = useState(false);
    const [totalIndustries, setTotalIndustries] = useState(0);
    const [pageSize, setPageSize] = useState(10);
    const [currentPage, setCurrentPage] = useState(1);
    const [openModal, setOpenModal] = useState(false);
    const [editingIndustry, setEditingIndustry] = useState(null);
    const [form] = Form.useForm();
    const pageSizeOptions = [10, 30, 50, 80, 120];
    const {
        data: industries,
        loading: loadingPageData,
        refetch: refetchIndustries,
    } = useApiFetch('/api/industries', (data) => {
        setTotalIndustries(data.meta.total);
        return data.data;
    });
    useEffect(() => {
        if (editingIndustry) {
            form.setFieldsValue(editingIndustry);
        } else {
            form.resetFields();
        }
    }, [editingIndustry]);

    useEffect(
        (prev, curr) => {
            refetchIndustries(
                `/api/industries?${qs.stringify({
                    take: pageSize,
                    skip: (currentPage - 1) * pageSize,
                    searchText: searchText || undefined,
                })}`,
            );
        },
        [pageSize, currentPage, searchText],
    );

    const handleDeleteIndustry = async (id) => {};
    const handleOnFormSubmit = async (values) => {
        try {
            setUpdatingIndustries(true);
            if (editingIndustry) {
                await apiClient.put(`/api/industries?industryId=${editingIndustry.id}`, values);
                message.success('New industry created successfully');
            } else {
                await apiClient.post('/api/industries', values);
                message.success('Industry updated successfully');
            }
            refetchIndustries();
        } catch (e) {
            message.error('Failed to save industry');
        } finally {
            setUpdatingIndustries(false);
            setOpenModal(false);
            setEditingIndustry(null);
        }
    };
    const datasource = [];
    industries?.map((industry) => {
        const { id, name, shortDescription, createdAt, createdBy, lastModifiedBy, updatedAt } = industry;
        return datasource.push({
            key: id,
            name: (
                <>
                    <Typography.Text>{name}</Typography.Text>
                    <Typography.Text type="secondary">{shortDescription}</Typography.Text>
                </>
            ),
            shortDescription,
            created: <Created DateAndTimeFormat={DateAndTimeFormat} createdAt={createdAt} createdBy={createdBy} />,
            modified: (
                <Modified DateAndTimeFormat={DateAndTimeFormat} updatedAt={updatedAt} lastModifiedBy={lastModifiedBy} />
            ),
            action: (
                <div className="table-actions">
                    <Button
                        onClick={() => {
                            setEditingIndustry(industry);
                            setOpenModal(true);
                        }}
                        className="btn-icon"
                        type="info"
                        size="default"
                        shape={'round'}
                    >
                        <FeatherIcon icon="edit" size={14} />
                    </Button>
                    <Popconfirm
                        placement="topLeft"
                        title={
                            <>
                                Are you sure to delete&nbsp;
                                <Typography.Text type="danger">{name}?</Typography.Text>
                                This action cannot be undone.
                            </>
                        }
                        onConfirm={() => handleDeleteIndustry(id)}
                        okText="Delete"
                        okType="danger"
                        cancelText="No"
                    >
                        <Button className="btn-icon" type="danger" shape="round">
                            <FeatherIcon icon="trash" size={14} />
                        </Button>
                    </Popconfirm>
                </div>
            ),
        });
    });

    const usersTableColumns = [
        {
            title: 'Name',
            dataIndex: 'name',
            key: 'name',
        },
        {
            title: 'Modified',
            dataIndex: 'modified',
            key: 'modified',
            align: 'center',
        },
        {
            title: 'Created',
            dataIndex: 'created',
            key: 'created',
            align: 'center',
        },
        {
            title: 'Actions',
            dataIndex: 'action',
            key: 'action',
            fixed: 'right',
        },
    ];

    const onShowSizeChange = async (current, pageSize) => {
        setPageSize(pageSize);
    };

    return (
        <>
            <CardToolbox>
                <PageHeader
                    routes={[
                        {
                            path: '/admin/overview',
                            icon: 'home',
                        },
                        {
                            breadcrumbName: 'Industries',
                            path: '/admin/industries',
                        },
                    ]}
                    title="Industries"
                    subTitle={<span className="title-counter">{totalIndustries} Industries </span>}
                    buttons={[
                        <Button
                            icon={<FeatherIcon icon="plus" size={16} />}
                            size="default"
                            type="primary"
                            onClick={() => setOpenModal(true)}
                        >
                            Add New
                        </Button>,
                        // <Button className="btn-add_new" size="default" type="primary" key="1">
                        //   <Link to="/admin/users/add-user/info">+ Add New User</Link>
                        // </Button>,
                        // <Button
                        //     onClick={exportUsers}
                        //     loading={exporting}
                        //     size="middle"
                        //     type="primary"
                        //     color="primary"
                        //     icon={!exporting && <FeatherIcon icon="download" size={14} />}
                        // >
                        //     Export CSV
                        // </Button>,
                    ]}
                />
            </CardToolbox>

            <Main>
                <Row gutter={15}>
                    <Col md={24}>
                        {/* <UserListTable users={users} /> */}
                        <Cards headless>
                            <>
                                <TableWrapper className="table-order table-responsive">
                                    <Table
                                        // rowSelection={rowSelection}
                                        dataSource={datasource}
                                        columns={usersTableColumns}
                                        loading={loadingPageData}
                                        pagination={{
                                            pageSize: pageSize,
                                            // defaultCurrent: 1,
                                            current: currentPage,
                                            total: totalIndustries,
                                            showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} contacts`,
                                            pageSizeOptions,
                                            onShowSizeChange: onShowSizeChange,
                                            showSizeChanger: true,
                                            onChange: (page, pageSize) => {
                                                if (page !== currentPage) {
                                                    setCurrentPage(page);
                                                }
                                            },
                                        }}
                                    />
                                </TableWrapper>
                            </>
                        </Cards>
                    </Col>
                </Row>
            </Main>

            <Modal
                title="Add New Industry"
                open={openModal}
                onCancel={() => {
                    setOpenModal(false);
                    setEditingIndustry(null);
                }}
                footer={null}
            >
                <BasicFormWrapper>
                    <Form onFinish={handleOnFormSubmit} layout="vertical" form={form} name="add_section_modal">
                        <Form.Item
                            name="name"
                            label="Name"
                            rules={[
                                {
                                    required: true,
                                    message: 'Please input the industry name',
                                },
                                {
                                    max: 23,
                                    message: 'Name cannot be more than 23 characters',
                                },
                            ]}
                        >
                            <Input />
                        </Form.Item>

                        <Form.Item
                            name="shortDescription"
                            label="Short Description"
                            rules={[
                                {
                                    required: true,
                                    message: 'Please input the short description',
                                },
                                {
                                    max: 72,
                                    message: 'Short description cannot be more than 72 characters',
                                },
                            ]}
                        >
                            <Input />
                        </Form.Item>
                        <div className="sDash_form-action">
                            <Button
                                size={'default'}
                                onClick={() => {
                                    setOpenModal(false);
                                    setEditingIndustry(null);
                                }}
                                type="light"
                            >
                                Cancel
                            </Button>
                            <Button size={'default'} loading={updatingIndustries} type="primary" htmlType="submit">
                                {updatingIndustries ? 'Saving...' : editingIndustry ? 'Update' : 'Save'}
                            </Button>
                        </div>
                    </Form>
                </BasicFormWrapper>
            </Modal>
        </>
    );
}

export default IndustriesList;
